<template>
    <div class="monthly-chart">
        <DashboadCard style="min-height: 200px; height: 100%;">
            <div class="monthly-chart__header">
                <DashboardIcon icon="show_chart" color="#556EE6" />
                <div class="monthly-chart__header-texts">
                    <div class="monthly-chart__title">Envíos por Mes</div>
                    <div class="monthly-chart__subtitle">Evolución de envíos en los últimos 6 meses</div>
                </div>
            </div>
            <div class="monthly-chart__container">
                <LineChart v-if="chartData.length" :chartLabels="chartLabels" :chartData="chartData" :height="280"
                    width="100%" />
                <div v-else class="monthly-chart__empty">Sin datos disponibles</div>
            </div>
        </DashboadCard>
    </div>
</template>

<script>
import DashboadCard from './DashboadCard.vue';
import DashboardIcon from './DashboardIcon.vue';
import LineChart from './LineChart.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'MonthlyChartSection',
    components: {
        DashboadCard,
        DashboardIcon,
        LineChart
    },
    computed: {
        ...mapGetters(['monthlyDeliveries']),
        chartLabels() {
            return (this.monthlyDeliveries || []).map(d => d.month);
        },
        chartData() {
            return (this.monthlyDeliveries || []).map(d => d.count);
        }
    }
}
</script>

<style scoped>
.monthly-chart__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.monthly-chart__header-texts {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.monthly-chart__title {
    font-size: 0.95rem;
    font-weight: 600;
}

.monthly-chart__subtitle {
    font-size: 0.8rem;
    opacity: 0.6;
}

.monthly-chart__container {
    height: 280px;
    position: relative;
}

.monthly-chart__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    font-size: 0.9rem;
}
</style>
